<template lang="html">
  <div class="user-message-history--inner">
    <div class="user-details-toolbar">
      <div class="user-details-toolbar__items">
        <select-list
          class="toolbar-nav"
          :title="$route.params.subtype"
          v-model="selectedType"
        >
          <select-option
            value="read"
            name="read"
          >
            <span>read</span>
          </select-option>

          <select-option
            value="unread"
            name="unread"
          >
            <span>unread</span>
          </select-option>

          <select-option
            value="all"
            name="all"
          >
            <span>all</span>
          </select-option>

        </select-list>
        <search
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>
        <button
          class="btn--create"
          @click="showCreate = true"
        >
          <i class="ico--create"></i>
        </button>
      </div>
    </div>

    <check-data-list
      label="loading"
      v-if="isDataLoading || isEmpty"
      :isLoading="isDataLoading"
      :isEmpty="isEmpty"
    >
    </check-data-list>

    <tbl
      :scrollable="true"
      :dataLoading="isDataLoading"
      :class="{'data-loading': showDataLoading}"
      v-else
    >
      <tbl-inner v-if="!isDataLoading">
        <tbl-head>
          <tbl-row>
            <tbl-td
              name="no"
              :sort="true"
              @click.native="sort('id')"
            >
              no
            </tbl-td>
            <tbl-td
              name="request"
              :sort="true"
              @click.native="sort('content')"
            >
              content
            </tbl-td>

            <tbl-td
              name="subject"
              :sort="true"
              @click.native="sort('title')"
            >
              title
            </tbl-td>

            <tbl-td name="read">
              read
            </tbl-td>

            <tbl-td
              name="admin-ip"
              :sort="true"
              @click.native="sort('admin_ip')"
            >
              admin ip
            </tbl-td>

            <tbl-td
              name="from"
              :sort="true"
              @click.native="sort('admin_id')"
            >
              from
            </tbl-td>

            <tbl-td
              name="date"
              :sort="true"
              @click.native="sort('created_at')"
            >
              created date
            </tbl-td>
          </tbl-row>
        </tbl-head>
        <tbl-body>
          <tbl-row
            v-for="(item, i) in messages"
            :key="i"
            @click.native="showMessageModal(item)"
          >
            <tbl-td name="no">
              {{ generateNumber(i, params.page, params.rows, params.sort, messageCount || 0) }}
            </tbl-td>
            <tbl-td name="request"
              :isHtml="true"
              :logs="item.content"
              >
            </tbl-td>

            <tbl-td name="subject"
              :isHtml="true"
              :logs="item.title"
            >
              {{item.title}}
            </tbl-td>

            <tbl-td name="result">
              {{item.read_at | date}}
            </tbl-td>

            <tbl-td name="admin-ip">
              {{item.admin_ip || '-'}}
            </tbl-td>

            <tbl-td name="admin">
              {{item.admin}}
            </tbl-td>

            <tbl-td name="from">
              {{item.created_at | date}}
            </tbl-td>

          </tbl-row>
        </tbl-body>
      </tbl-inner>

      <tbl-footer>
        <pagination
          :total="messageCount"
          v-model="params.page"
          :rows="params.rows"
          @page="trigger"
        >
        </pagination>
      </tbl-footer>

    </tbl>

    <modal
      class="modal--create-message"
      title="create message"
      v-if="showCreate"
      :activate="showCreate"
      @activate="showCreate = $event"
    >
      <template slot="body">
        <div class="form-con">
          <div class="form-items">
            <div class="form-lbl"><span>Title</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <quill-editor
                  ref="title"
                  :options="quillTitleConfig"
                  v-model="messageModel.title"
                >
                </quill-editor>
              </div>
            </div>
          </div> <!-- form-items -->

          <div class="form-items">
            <div class="form-lbl"><span>Content</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <quill-editor
                  ref="content"
                  :options="quillContentConfig"
                  v-model="messageModel.content"
                >
                </quill-editor>
              </div>
            </div>
          </div> <!-- form-items -->

        </div> <!-- form-con-->
      </template>

      <template slot="footer">
        <button
          class="btn--confirm -withlabel"
          @click="addNewMessage()"
        >
          <i class="ico--create"></i>
          <span>create</span>
        </button>
      </template>
    </modal>

    <modal
      class="modal--view-message"
      title="view message"
      v-if="showMessage"
      :activate="showMessage"
      @activate="showMessage = $event"
    >
      <template slot="body">
        <div class="form-con">
          <div class="form-items">
            <div class="form-lbl"><span>Created at</span></div>
            <div class="form-data">
              <span>{{ messageUpdateModel.created_at | date }}</span>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Read</span></div>
            <div class="form-data">
              <span>{{ messageUpdateModel.read_at | date }}</span>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Admin ip</span></div>
            <div class="form-data">
              <span>{{ messageUpdateModel.admin_ip || '-' }}</span>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>From</span></div>
            <div class="form-data">
              <span>{{ messageUpdateModel.admin }}</span>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Title</span></div>
            <div class="form-data">
              <span v-html="messageUpdateModel.title"></span>
            </div>
          </div> <!-- form-items -->

          <div class="form-items">
            <div class="form-lbl"><span>Content</span></div>
            <div class="form-data">
              <span v-html="messageUpdateModel.content"></span>
            </div>
          </div> <!-- form-items -->

        </div> <!-- form-con-->
      </template>
    </modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
//= mixins
import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'
import { swal } from '@/assets/js/mixins/base/Swal'

//= components
import Modal from '@/components/base/Modal'
import Search from '@/components/base/search/Search'
import Pagination from '@/components/base/Pagination'
import CheckDataList from '@/components/base/CheckDataList'
import TextArea from '@/components/base/TextArea'
import { quillEditor } from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: 'user-message-history',

  components: {
    Modal,
    Search,
    Pagination,
    CheckDataList,
    TextArea,
    'quill-editor': quillEditor
  },

  mixins: [
    getListStatus,
    swal
  ],
  computed: {
    ...mapState('support', [ 'messages', 'messageCount' ])
  },

  created () {
    this.search(this.generate(this.params))
  },

  watch: {
    $route (to, from) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      if (to.params.status !== from.params.status) {
        this.showDataLoading = false
      }
      this.search(this.generate(to.query))
    }
  },

  data () {
    let params = Object.assign(
      {
        page: 1,
        rows: 10,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )
    return {
      params,
      isDataLoading: true,
      showDataLoading: false,
      isEmpty: false,
      showCreate: false,
      showMessage: false,

      // selectedList: null,
      filterBy: [
        {
          value: 'title',
          display: 'title'
        },

        {
          value: 'content',
          display: 'content'
        },

        {
          value: 'admin_ip',
          display: 'admin ip'
        },

        {
          value: 'admin',
          display: 'admin name'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },

        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      messageModel: this.getDefaultModel(),
      messageUpdateModel: this.getDefaultModel(),

      quillTitleConfig: {
        placeholder: 'Title here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      },

      quillContentConfig: {
        placeholder: 'Content here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      }
    }
  },

  methods: {
    ...mapActions('support', [ 'getUserMessagesByStatus', 'createMessages' ]),

    getDefaultModel () {
      return {
        content: '',
        user_id: '',
        title: ''
      }
    },

    trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    },

    async search (query) {
      this.params = query || this.params

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }
      console.log( '------------>', this.$route.params )
      let stat = this.$route.params.subtype
      await this.getUserMessagesByStatus({ userId: this.$route.params.id, params: this.params, status: stat })

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.messages.length) {
        this.isEmpty = true
      }
    },

    async addNewMessage () {
      let success = async () => {
        let result = await this.createMessages(this.messageModel)

        if (result.status === 201) {
          this.$alert('success', 'You have successfully created a message.', {}, '', 'Success')
          this.showCreate = false
          this.messageModel = _.assign(this.messageModel, this.getDefaultModel())
          this.search()
        }
      }

      this.messageModel.user_id = parseInt(this.$route.params.id, 10) || null

      if (this.messageModel.title === '' || this.messageModel.content === '' ||
          this.messageModel.user_id === null) {
        this.$alert('error', 'All fields required.', {}, '', 'Error')
        return
      }

      if (this.messageModel.title.replace(/(<([^>]+)>)/ig, ' ').trim() === '' ||
          this.messageModel.content.replace(/(<([^>]+)>)/ig, ' ').trim() === '' ||
          this.messageModel.user_id === null) {
        this.$alert('error', 'All fields required.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, 'Create Message')
    },

    showMessageModal (item) {
      this.messageUpdateModel = item
      this.showMessage = true
    },

    sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.search()
    }
  }

}
</script>
